import { styled } from '@mui/material/styles';
import Button from '../../../../../../shared/library/Button';

export const StyledButton = styled(Button)(({ theme }) => {
  return {
    [theme.breakpoints.up('md')]: {
      minWidth: '215px',
    },
  };
});
